import {useState} from 'react'
import {translateApiError} from '@/lib/errors'

export function useExportActions(downloadExcel: () => Promise<void>, openPrint: () => Promise<void>) {
  const [pending, setPending] = useState<'excel' | 'print' | null>(null)
  const [error, setError] = useState<string | null>(null)

  async function handle(kind: 'excel' | 'print') {
    setError(null)
    setPending(kind)
    try {
      if (kind === 'excel') await downloadExcel()
      else await openPrint()
    } catch (err) {
      setError(translateApiError(err))
    } finally {
      setPending(null)
    }
  }

  return {
    pending,
    error,
    handleExcel: () => handle('excel'),
    handlePrint: () => handle('print'),
  }
}
